export function useCssColors() {
  const bodyStyles = getComputedStyle(document.body)

  const getCssPropertyValue = (name) => {
    return bodyStyles.getPropertyValue(name)
  }

  return {
    getCssPropertyValue,
  }
}